module.exports = __webpack_public_path__ + "static/img/PWZD.2974281.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/PWZD.png
// module id = MAOQ
// module chunks = 1